import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import Button from 'src/components/atoms/Button'
import Pill from 'src/components/atoms/Pill'
import POSCard from 'src/components/cards/POSCard'
import Page from 'src/components/layouts/Page'
import LogoClover from 'src/logos/LogoClover'
import LogoSquare from 'src/logos/LogoSquare'
import css from './Pos.module.scss'
import EmptyPage from 'src/components/molecules/EmptyPage'

const axios = require('axios')

export default function Pos() {
	const { user, token, permissions } = useSelector(state => state.auth)

	const pos = [
		{
			name: 'Square',
			logo: <LogoSquare height='28px' />,
			value: 'square',
		},
	]

	const posSync = () => {
		// const { user, token } = utils.getAuth()
		axios
			.get(`https://api.dev-box.livecart-production.com/merchant/POS/init/${user.id}`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then(res => {
				toast.success('POS Synchronized')
			})
			.catch(error => {
				if (error.response) {
					toast.error(error.response.data.message)
				} else if (error.request) {
					toast.error(error.request)
				} else {
					toast.error(error.message)
				}
			})
	}

	const isPos = user && user.POS && user.POS.enabled
	return (
		<Page>
			{permissions.read.includes('pos') ? (
				<div className={css['box']}>
					<header className={css['header']}>
						{/* <div> */}
						<h2 className={css['title']}>Point of Sale</h2>
						{/* <p>Connect your POS system to Livecart</p> */}
						{/* </div> */}
						<Pill
							variant='secondary'
							label={isPos ? 'Connected' : 'Not Connected'}
							color={isPos ? 'success' : 'error'}
							iconLeft={isPos ? 'fas fa-check-circle' : 'fad fa-circle'}
						/>
					</header>
					{!isPos && (
						<>
							<p className={css['text']}>Connect your POS system to Livecart:</p>
							<div className={css['cards']}>
								{pos.map(po => {
									return (
										<POSCard
											name={po.name}
											logo={po.logo}
											value={po.value}
										/>
									)
								})}
							</div>
							<p className={css['text-2']}>
								Your POS isn’t listed above?{' '}
								<a href='#'>Request a POS to be added.</a> <br />
								{/* We will inform you as soon as it's ready! */}
							</p>
						</>
					)}
					{isPos && (
						<>
							<p className={css['text']}>Synchronize POS</p>

							<Button
								label='Synchronize Square POS'
								iconLeft='fad fa-sync'
								action={posSync}></Button>
						</>
					)}
				</div>
			) : (
				<EmptyPage
					title='You don’t have permission to view anything on this page'
					text='Ask your employer for access'
					iconName='fad fa-lock'
				/>
			)}
		</Page>
	)
}
